import { FormField, InputSelectField } from '@tempmee/react';
import { forwardRef, memo, type Ref } from 'react';

interface IAssistedHygieneFieldProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
  hasError?: boolean;
}

const OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

const Component = (
  { value, onChange, hasError }: IAssistedHygieneFieldProps,
  ref: Ref<HTMLDivElement>,
) => (
  <div ref={ref} data-testid="assisted-hygiene-field" data-cy="assisted-hygiene-field">
    <FormField label="Assisted Hygiene">
      <InputSelectField<boolean>
        options={OPTIONS}
        value={value}
        onChange={onChange}
        placeholder="Select"
        isError={Boolean(hasError)}
      />
    </FormField>
  </div>
);

export const AssistedHygieneField = memo(forwardRef(Component));
